import { useTranslation } from "react-i18next";
import {
    TEXT_FIELD_TYPE,
    DATE_RANGE_FIELD_TYPE,
    AUTOCOMPLETE_FIELD_TYPE,
    BOOLEAN_FIELD_TYPE,
} from "../../helpers/constants";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import {UpdateBankingDialog} from "./UpdateBankingDialog"
import { useBankingFilteringData } from "../../services/bankingService";

import { MatchBankingWithAgreementDialog } from "./MatchBankingWithAgreementDialog";
import { AgreementPassportButton } from "../AgreementsPage/AgreementPassportDialog/AgreementPassportButton";
import LinkIcon from '@mui/icons-material/Link';

import DateService from "../../services/dateService";
import SelectFieldService from "../../services/selectFieldService";

export const BANKING_TABLE_NAME = "bankings_table";

export const useBankingTableFieldsConfig = () => {
    const { t } = useTranslation();

    const { data: filteringData } = useBankingFilteringData()

      const { openDialog: openUpdateBankingDialog } = useDialogBetter();
      const { openDialog: openMatchBankingWithAgreementDialog } = useDialogBetter();
    
      const handleClickEdit = (e, bankingId) => {
        e.stopPropagation();
        e.preventDefault();
        openUpdateBankingDialog({
          Component: UpdateBankingDialog,
          componentProps: {
            bankingId: bankingId,
          },
        });
      };


    const handleClickMatchBankingWithAgreement = (e, bankingId, investmentId, bankingIsWithdrawal) => {
        e.stopPropagation();
        e.preventDefault();
        openMatchBankingWithAgreementDialog({
          Component: MatchBankingWithAgreementDialog,
          componentProps: {
            bankingId: bankingId,
            investmentId: investmentId,
            bankingIsWithdrawal: bankingIsWithdrawal,
          },
        });
      };



    return [
        {
            name: "banking_name",
            getValueCallback: (rowData) => rowData.banking_name,
            label: t("bankings.banking_name"),
            filterType: TEXT_FIELD_TYPE,
            sortable: true
        },
        {
            name: "created",
            getValueCallback: (rowData) =>
                DateService.convertDatetimeFromBackendToFormatYYYYMMDD(rowData.created),
            label: t("bankings.created"),
            filterType: DATE_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => ({
                style: { minWidth: "100px" },
            }),
            sortable: true,
        },
        {
            name: "banking_date_match",
            getValueCallback: (rowData) =>
                DateService.convertDatetimeFromBackendToFormatYYYYMMDD(rowData.banking_date_match),
            label: t("bankings.banking_date_match"),
            filterType: DATE_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => ({
                style: { minWidth: "100px" },
            }),
            sortable: true,
        },
        {
            name: "agreement_client",
            getValueCallback: (rowData) => rowData.agreement_client,
            label: t("bankings.agreement_client"),
            filterType: TEXT_FIELD_TYPE,
        },
        {
            name: "agreement_local",
            getValueCallback: (rowData) => rowData.agreement_local,
            label: t("bankings.agreement_local"),
            filterType: TEXT_FIELD_TYPE,
        },
        {
            name: "banking_bank",
            getValueCallback: (rowData) => rowData.banking_bank,
            label: t("bankings.banking_bank"),
            filterType: AUTOCOMPLETE_FIELD_TYPE,
            fieldConfig: {
                optionLabelKey: "bank_name",
                options: filteringData?.bank,
                multiple: true,
                isObjectOption: true,
                disableClearable: true
            },
        },
        {
            name: "banking_nr",
            getValueCallback: (rowData) => rowData.banking_nr,
            label: t("bankings.banking_nr"),
            filterType: TEXT_FIELD_TYPE,
            sortable: true,
        },
        {
            name: "banking_kind",
            getValueCallback: (rowData) => rowData.banking_kind,
            label: t("bankings.banking_kind"),
            filterType: AUTOCOMPLETE_FIELD_TYPE,
            fieldConfig: {
                optionLabelKey: "bankingkind_name",
                options: filteringData?.banking_kind,
                isObjectOption: true,
                disableClearable: true,
                multiple: true
            },
        },
        {
            name: "banking_invest",
            getValueCallback: (rowData) => rowData.banking_invest?.investment_name_sales,
            label: t("bankings.banking_invest"),
            filterType: AUTOCOMPLETE_FIELD_TYPE,
            fieldConfig: {
                optionLabelKey: "investment_name_sales",
                options: filteringData?.investment,
                isObjectOption: true,
                disableClearable: true,
                multiple: false
            },
        },
        {
            name: "agreement_notarial_deed",
            getValueCallback: (rowData) => rowData.agreement_notarial_deed,
            label: t("bankings.agreement_notarial_deed"),
            filterType: TEXT_FIELD_TYPE,
        },
        {
            name: "banking_note",
            getValueCallback: (rowData) => rowData.banking_note,
            label: t("bankings.banking_note"),
            filterType: TEXT_FIELD_TYPE,
        },
        {
            name: "banking_active",
            getValueCallback: (rowData) => SelectFieldService.getLabelOptionsTrueOrFalse(rowData.banking_active),
            label: t("bankings.banking_active"),
            filterType: BOOLEAN_FIELD_TYPE,
        },
        {
            name: "edit_button",
            getValueCallback: (rowData) => (
                <IconButton
                    color={"primary"}
                    onClick={(e) => handleClickEdit(e, rowData.id)}
                >
                    <EditIcon />
                </IconButton>
            ),
            label: t("bankings.edit"),
            allowChangeVisibility: false,
            excludedFromExport: true,
        },
        {
            name: "",
            getValueCallback: (rowData) => ( 
                rowData.banking_is_current || !rowData.banking_active
                    ? null 
                    : rowData.banking_agreement ? <AgreementPassportButton agreement={{id: rowData.banking_agreement}} /> 
                    : <IconButton
                        color={"primary"}
                        onClick={(e) => handleClickMatchBankingWithAgreement(e, rowData.id, rowData.banking_invest?.id, rowData.banking_is_withdrawal)}
                    >
                        <LinkIcon />
                    </IconButton>
            ),
            label: t("bankings.agreementPassport"),
            allowChangeVisibility: false,
            excludedFromExport: true,
        },


    ];
};
